import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Tabs {
    constructor() {
    }

    init() {
        this.bindEvents();
        this.goToTab();
    }

    bindEvents() {
        $(document).on('click', '.tabs-item', e => {
            const tab = $(e.currentTarget);
            const tabContent = tab.attr('id');
            const hash = tab.attr('id');

            // Toggle mobile menu
            if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
                this.toggleMobileMenu(e.currentTarget);
            }

            this.changeTab(`#${hash}`, false);
        });
    }

    toggleMobileMenu(el) {
        $(el).closest('ul').toggleClass('open');
    }

    changeTab(hash, updateHistory) {
        const tab = $(hash);
        const tabContent = hash.replace('#', '');

        if (hash.length && $('.tabs-item').length) {
            // Remove current active class from tab
            tab.siblings('.tabs-item').removeClass('tabs-item--active');

            // Add active class to tab
            tab.addClass('tabs-item--active');

            // Remove current active class from tab content
            tab.parent().next('.tabs-content').children('.tabs-content-item').removeClass('tabs-content-item--active');

            // Add active class to tab content
            $(`#content-${tabContent}`).addClass('tabs-content-item--active');

            // Update history
            if (updateHistory) {
                window.history.replaceState('', '', hash);
            }
        }
    }

    goToTab() {
        this.changeTab(document.location.hash, false);
    }
}

export default Tabs;

$(() => {
	const tabs = new Tabs();
	tabs.init();
});